import { useDebouncedValue } from "@/react/hooks/utils/useDebouncedValue";

const DEBOUNCE_DELAY = 500;

interface BillingAddressAttributes {
  address_city?: string;
  address_country?: string;
  address_line1?: string;
  address_postal_code?: string;
  address_state?: string;
}

// Returns a single debounced key representing the full billing address.
// Using one timer instead of per-field timers ensures that atomic updates
// from the Stripe AddressElement (which sets all fields in one onChange event)
// only trigger a single price preview call after the debounce delay.
export const useDebouncedBillingAddress = (
  attributes: BillingAddressAttributes | undefined,
) => {
  const addressKey = [
    attributes?.address_line1,
    attributes?.address_state,
    attributes?.address_city,
    attributes?.address_postal_code,
    attributes?.address_country,
  ].join("|");

  return useDebouncedValue(addressKey, DEBOUNCE_DELAY);
};
